<mat-dialog-content class="overflow-hidden" style="max-height:inherit; max-width: inherit;">
    <div class="d-flex justify-content-between">
        <h5 class="fw-semibold">Brennstoffzellendaten vom Gerät:&nbsp;{{ deviceName }}</h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseDialogClicked()">
    </div>

    <div class="d-flex justify-content-center align-items-center mb-4">
        Von vor&nbsp;
        <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
            [(ngModel)]="fromDate" (ngModelChange)="setFromDate(fromDate)" min="1" max="14">
        &nbsp;Tagen&nbsp;bis zu
        <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
            [(ngModel)]="toDate" (ngModelChange)="setToDate(toDate)" min="0" max="13">
        &nbsp;Tagen
        <button (click)="removeData(null)" class="btn rounded-0 btn-outline-success ms-5 ms-sm-5 btn-sm">
            Update
        </button>
    </div>
    <div class="h-100 overflow-auto">
        <div class="h-100">
            <canvas id="MeasurementChart"></canvas>
            <canvas id="ErrorChart"></canvas>
        </div>
    </div>
</mat-dialog-content>
<div mat-dialog-actions class="d-flex justify-content-between m-4">
    <button (click)="exportChart()" class="btn rounded-0 btn-outline-success btn-sm"> Export
    </button>
    <button (click)="onCloseDialogClicked()" class="btn rounded-0 btn-outline-danger btn-sm">
        Schließen
    </button>
</div>